// src/components/modals/EditCategoriaModal.jsx
import React, { useState, useEffect } from 'react';
import { put, get } from '../../helpers/apiHelper';
import Swal from 'sweetalert2';
import useAuthStore from '../../store/authStore';

function EditCategoriaModal({ isOpen, categoria, onClose, onCategoriaUpdated }) {
    const [nombre, setNombre] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [activa, setActiva] = useState(true);
    const [marcaId, setMarcaId] = useState(null);
    const { user } = useAuthStore();

    useEffect(() => {
        if (isOpen && categoria) {
            setNombre(categoria.nombre || '');
            setDescripcion(categoria.descripcion || '');
            setActiva(categoria.activa !== undefined ? categoria.activa : true);
            fetchMarcaId();
        }
    }, [isOpen, categoria]);

    const fetchMarcaId = async () => {
        try {
            const marcas = await get(`marcas/user/${user.userId}`);
            if (marcas.length > 0) {
                setMarcaId(marcas[0]._id);
            }
        } catch (error) {
            console.error('Error fetching marca:', error);
        }
    };

    const handleUpdate = async () => {
        if (!nombre.trim()) {
            Swal.fire({
                title: 'Error',
                text: 'El nombre de la categoría es obligatorio.',
                icon: 'error',
                confirmButtonText: 'Aceptar',
            });
            return;
        }





        if (!marcaId) {
            Swal.fire({
                title: 'Error',
                text: 'No se pudo identificar la marca. Inicie sesión nuevamente.',
                icon: 'error',
                confirmButtonText: 'Aceptar',
            });
            return;
        }

        try {
            await put(`productos/${marcaId}/categorias/${categoria._id}`, {
                nombre: nombre.trim(),
                descripcion: descripcion.trim(),
                activa,
                marca: marcaId
            });

            Swal.fire({
                title: 'Categoría Actualizada',
                text: 'La categoría ha sido actualizada exitosamente',
                icon: 'success',
                confirmButtonText: 'Aceptar'
            });

            onCategoriaUpdated();
            onClose();
        } catch (error) {
            console.error('Error updating categoria:', error);
            // Solo mostrar error si no es un error de servidor interno
            if (error.message && !error.message.includes('Internal server error')) {
                Swal.fire({
                    title: 'Error',
                    text: error.message,
                    icon: 'error',
                    confirmButtonText: 'Aceptar'
                });
            } else {
                Swal.fire({
                    title: 'Error',
                    text: 'No se pudo actualizar la categoría. Intente de nuevo.',
                    icon: 'error',
                    confirmButtonText: 'Aceptar'
                });
            }
        }
    };

    if (!isOpen || !categoria) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-4 sm:p-6 rounded-lg w-full max-w-md mx-4">
                <h2 className="text-xl sm:text-2xl font-bold mb-4">Editar Categoría</h2>

                <label className="block mb-2 font-semibold">Nombre *</label>
                <input
                    type="text"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    placeholder="Ej: Electrónicos"
                    className="w-full mb-4 p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <label className="block mb-2 font-semibold">Descripción</label>
                <textarea
                    value={descripcion}
                    onChange={(e) => setDescripcion(e.target.value)}
                    placeholder="Descripción opcional de la categoría"
                    rows="3"
                    className="w-full mb-4 p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                ></textarea>

                <label className="flex items-center mb-4">
                    <input
                        type="checkbox"
                        checked={activa}
                        onChange={(e) => setActiva(e.target.checked)}
                        className="mr-2"
                    />
                    <span className="text-sm text-gray-700">Categoría activa</span>
                </label>

                <div className="flex justify-end space-x-4">
                    <button
                        onClick={onClose}
                        className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleUpdate}
                        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
                    >
                        Actualizar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default EditCategoriaModal; 